// store/modules/user.js

export default {
    namespaced: true, // 命名空间模块化
    state: () => ({
        showBaseInfo: true,// 显示主详情
        showMaterial: false, //显示素材详情
        selectMaterial: {},// 选中的素材
        documentAssetDtoList: [],//文档全部素材列表
    }),
    mutations: {
       
        SET_BASE_INFO: (state, bool) => {
            state.showBaseInfo = bool;
        },
        SET_MATERIAL_INFO: (state, bool) => {
            state.showMaterial = bool;
        },
        SET_SELECT__MATERIAL: (state, material) => {
            state.selectMaterial = material;
        },
        SET_DOCUMENTASSETDTOLIST: (state, list) => {
            state.documentAssetDtoList = list;
        },
    },
    actions: {
        setBaseInfo({ commit }, bool) {
            commit("SET_BASE_INFO", bool);
        },
        setMaterial({ commit }, bool) {
            commit("SET_MATERIAL_INFO", bool);
        },
        setSelectMaterial({ commit }, material) {
            commit("SET_SELECT__MATERIAL", material);
        },
        setDocumentAssetDtoList({ commit }, list) {
            commit("SET_DOCUMENTASSETDTOLIST", list);
        },
    },
    getters: {
        isAuthenticated(state) {
            return !!state.userInfo;
        },
    },
};
